import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexAlphaNumericWithSpecialChar =
    '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]+$'

  return Yup.object({
    billNo: Yup.string().nullable(),
    parentBillNo: Yup.string().nullable(),
    locationIdentificationType: Yup.string().nullable().required(requiredMessage),
    consignmentLocation: Yup.string().nullable().required(requiredMessage).max(6, errMsgMaxLength + " 6"),
    consignmentLocationName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    terminalPierName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(70, errMsgMaxLength + " 70"),
    monetaryAmountType: Yup.string().nullable().max(3, errMsgMaxLength + " 3"),
    monetaryAmount: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    currencyCode: Yup.string().nullable(),
    chargeCategoryCode: Yup.string().nullable(),
    paymentArrangementCode: Yup.string().nullable(),
  })
}

export default makeValidationSchema
